import React from 'react';
import { Container, Image } from 'react-bootstrap';
import maintenanceImage from '../../assets/app/maintenance.png';

export const Maintenance = () => {
  return (
    <Container size='lg'>
      <Image src={maintenanceImage} alt='Maintenance Image' width={'100%'} height={'100%'} />
    </Container>
  );
};
